import React, {useEffect} from 'react';
import Login from '../components/login/login';
import {connect} from "react-redux";
import {_getShowPageBroken, _hideSpinner, _setShowPageBroken, _showSpinner} from "../store/system/service";

const LoginPage = (props) => {

    useEffect(() => {
        if (props.showPageBroken) {
            props.history.push('/pageUnavailable');
            props.setShowPageBroken(false);
            props.hideSpinner();
        }
    }, [props.showPageBroken]);


    // clear token

    return (
        <>
            <Login/>
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        showPageBroken: _getShowPageBroken(state)
    }
}


const mapDispatchToProps = {
    showSpinner: _showSpinner,
    hideSpinner: _hideSpinner,
    setShowPageBroken: _setShowPageBroken
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);
